import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { SharedCard } from '../../../../components/shared-card/card';
import { useTranslation } from 'react-i18next';
import PayoutService from '../../../../services/api/earnings';
import { useAuth } from '../../../../services/auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import OverlayLoader from '../../../../components/overlayLoader';

export default function PotentialEarnings({ user }) {
    const { t } = useTranslation();
    const { setIsAuthenticated, user: authUser } = useAuth();
    const navigate = useNavigate();

    const [potentialEarning, setPotentialEarning] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPotentialEarnings = async () => {
            try {
                const response = await PayoutService.getPotentialEarnings(setIsAuthenticated, navigate);
                setPotentialEarning(response);
            } catch (error) {
                console.error('Error fetching potential earnings:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPotentialEarnings();
    }, [setIsAuthenticated, navigate]);

    return (
        <>
            <OverlayLoader 
                open={loading}
                text={t('loading.earnings') + '...'}
            />
            <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="h4">
                    {t('dashboard.pages.my_earnings')}
                </Typography>

                <SharedCard>
                    <Typography variant="body1" gutterBottom>
                        {t('user_profile.potential_earnings')}
                    </Typography>

                    <Box display="flex" justifyContent="center" gap={1}>
                        <Typography variant="h1">
                            &#8377;{potentialEarning}
                        </Typography>
                        <Typography variant="h4">
                            <span>&#42;</span>
                        </Typography>
                    </Box>
                </SharedCard>
                <SharedCard>
                    <Typography variant="body1" gutterBottom>
                        {t('user_profile.disbursed_earnings')}
                    </Typography>
                    <Box display="flex" justifyContent="center" gap={1}>
                        <Typography variant="h1">
                            &#8377;0
                        </Typography>
                        <Typography variant="h4">
                            <span>&#42;</span>
                        </Typography>
                    </Box>
                </SharedCard>
                <Typography variant="body1">
                    <b>Disclaimer:</b>
                    {t('user_profile.earnings_disclaimer')}
                </Typography>
            </Box>
        </>
    );
}

PotentialEarnings.propTypes = {
    user: PropTypes.object.isRequired,
};
